import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InternalHomeService } from '../../../../container/internal/internal-home/internal-home.service';
import { Permissions } from '../../../../core/entities/permissions.model';
import { Rols } from '../../../../core/entities/rols.model';
import { Operations } from '../../../../core/entities/operations.model';
import { Wsdefs } from '../../../../core/entities/wsdefs.model';
import { Xmlfields } from '../../../../core/entities/xmlfields.model';
import { Typefinders } from '../../../../core/entities/typefinders.model';
import { Fieldlinks } from '../../../../core/entities/fieldlinks.model';
import { TranslateService } from '@ngx-translate/core';
import { PermissionsService } from '../../../../core/repositories/permissions.service';
import { Utils } from '../../../../core/utils/utils';
import * as _ from 'lodash';

@Injectable()
export class DialogsPermissionsService {

    wsdefs: Wsdefs = new Wsdefs();
    xmlfields: Xmlfields = new Xmlfields();
    typefinders: Typefinders = new Typefinders();
    fieldlinks: Fieldlinks = new Fieldlinks();

    clase: string = "";
    code: String = "";
    idpermisos: number = 0;
    tipoRol: String[] = [];
    tipoId: number[] = [];

    rols: Rols[] = new Array<Rols>();
    allrols: Rols[] = new Array<Rols>();
    allrolsFiltro: Rols[] = new Array<Rols>();

    permissions: Permissions[] = new Array<Permissions>();
    permissionsType: Permissions[] = new Array<Permissions>();
    operations: Operations[] = new Array<Operations>();

    permissionsTypeTrue: Permissions[] = new Array<Permissions>();
    rolsTrue: Rols[] = new Array<Rols>();

    originalRols: Rols[] = new Array<Rols>();
    originalRolsFiltro: Rols[] = new Array<Rols>();

    constructor(private internalHomeService: InternalHomeService,
                private translateService: TranslateService,
                private permissionsService: PermissionsService) { }

    init(data: any): Observable<boolean> {

      this.idpermisos = data.idpermisos;
      this.clase = data.clasepermisos;
      this.code = data.objectpermisos;
      this.tipoRol = [];
      this.tipoId = [];

      switch(this.clase) { 
        case this.translateService.instant('TABLAS.fieldlink'): { 
          this.fieldlinks = data.fieldlink;
          break; 
        } 
        case this.translateService.instant('TABLAS.wsdef'): { 
          this.wsdefs = data.wsdefs;
          break; 
        } 
        case this.translateService.instant('TABLAS.typefinder'): { 
          this.typefinders = data.typefinder;
          break; 
        } 
        case this.translateService.instant('TABLAS.xmlfield'): { 
          this.xmlfields = data.xmlfield
          break; 
        } 
      } 


      return forkJoin([this.internalHomeService.allPermissions(),
                      this.internalHomeService.allRolls(),
                      this.internalHomeService.allOperations()]).pipe(map(dataGroup => {

          this.permissions = dataGroup[0];
          this.rols = dataGroup[1];
          this.operations = dataGroup[2];

          this.allrols = _.cloneDeep(this.rols);
          this.allrolsFiltro = _.cloneDeep(this.rols);

          this.permissionsType = [];
          this.permissionsTypeTrue = [];
          this.rolsTrue = [];

          this.visualizaPermisos();

          return true;
      }));
    }

    /**
    * @description
    * Guarda o elimina los permissos correspondientes a cada rol (checKs)
    * @returns True si todo ha ido bien
    */
    gestionPermisos(rols?: Rols []){

      let originRolFiltro = new Array<Rols>();
      originRolFiltro =  _.cloneDeep(rols ?? []);

      for(let i = 0; i < this.originalRolsFiltro.length; i++){
        for(let x = 0; x < originRolFiltro.length; x++){
          if(this.originalRolsFiltro[i].code === originRolFiltro[x].code){
            this.originalRolsFiltro[i].operacion1 = _.cloneDeep(originRolFiltro[x].operacion1);
            this.originalRolsFiltro[i].operacion2 = _.cloneDeep(originRolFiltro[x].operacion2);
            this.originalRolsFiltro[i].operacion3 = _.cloneDeep(originRolFiltro[x].operacion3);
          }
        }
      }

      let permisoArray = [];
      let originRol = new Array<Rols>();
      originRol =  _.cloneDeep(this.originalRolsFiltro);

      for (let i = 0; i < originRol.length; i++) {
        if (originRol[i].operacion1 === true) {
          let permisoAdd1 = new Permissions();
          permisoAdd1.id = 0;
          permisoAdd1.operationId.id = this.tipoId[0];
          permisoAdd1.permissionableId = this.idpermisos;
          permisoAdd1.permissionableType = this.clase
          permisoAdd1.rolId.id = originRol[i].id;
          permisoAdd1.visibility = 0;
          if(this.clase === this.translateService.instant('TABLAS.xmlfield')){
            if (originRol[i].operacion3 === true) {
              permisoAdd1.visibility = 1;
            }else{
              permisoAdd1.visibility = 0;
            }
          }
          permisoArray.push(permisoAdd1);
        }

        if(this.clase != this.translateService.instant('TABLAS.fieldlink')){
          if (originRol[i].operacion2 === true) {
            let permisoAdd2 = new Permissions();
            permisoAdd2.id = 0;
            permisoAdd2.operationId.id = this.tipoId[1];
            permisoAdd2.permissionableId = this.idpermisos;
            permisoAdd2.permissionableType = this.clase
            permisoAdd2.rolId.id = originRol[i].id;
            permisoAdd2.visibility = 0;
            permisoArray.push(permisoAdd2);
          }
        }
      }

      if(permisoArray.length <= 0){
        return this.permissionsService.deleteAllPermission(this.idpermisos).pipe(map(data => {
          console.log(data);
          return true;
        }),catchError((error: any) => {
          console.log(error);
          throw error;
        }));
      }else{
        return this.permissionsService.postSetPermission(permisoArray).pipe(map(data => {
          console.log(data);
          return true;
        }),catchError((error: any) => {
          console.log(error);
          throw error;
        }));
      }
    }


    /**
    * @description
    * Comprueba si dos arrray permisions son iguales.
    * @param datoX array permission 1
    * @param datoY array permission 2
    * @returns True si son iguales
    */
    public compare(itemX:Rols[], itemY:Rols[]):boolean {
      //Ambos objetos están definidos y no son nulos
      if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

        for (let i = 0; i < itemX.length; i++) {
          for (let x = 0; x < itemY.length; x++) {
            if (itemX[i].operacion1 != itemY[i].operacion1) {
              return false;
            }
            if (itemX[i].operacion2 != itemY[i].operacion2) {
              return false;
            }
            if(this.clase === this.translateService.instant('TABLAS.xmlfield')){
              if (itemX[i].operacion3 != itemY[i].operacion3) {
                return false;
              }
            }
          }
        }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Filtro para todos las columnas de la tabla
  */
  public filterGlobalPermisos(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalRols = new Array<Rols>();
    originalRols = _.cloneDeep(this.allrolsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalRols.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalRols[i].code).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalRols[i]));
        }
      }
      this.rols = items;
      this.visualizaPermisos();
    } else {
      this.rols = originalRols;
      this.visualizaPermisos();
    }
  }


  /**
  * @description
  * Gestion para la visualizacion y carga de los permisos en el cuadro de dialogo
  */
  public visualizaPermisos(){
    for(let i = 0; i < this.rols.length; i++){

      /*Inicializamos estos atributos inventados a false (de todos los roles)*/
      this.rols[i].operacion1 = false;
      this.rols[i].operacion2 = false;
      this.rols[i].operacion3 = false;
    }

    /*Aqui recogemos todos los premisos pertenecientes al cuador de dialogo seleccionado*/
    for(let i = 0; i < this.permissions.length; i++){
      if(this.permissions[i].permissionableType === this.clase){
        this.permissionsType.push(this.permissions[i]);
      }
    }

    /*Aqui recogemos todos los premisos activos del registro seleccionado (IMPORTANTE)*/
    for(let i = 0; i < this.permissionsType.length; i++){
      switch(this.clase) { 
        case this.translateService.instant('TABLAS.fieldlink'): { 
          if(this.permissionsType[i].permissionableId === this.fieldlinks.id){
            this.permissionsTypeTrue.push(this.permissionsType[i]);
          }
          break; 
        } 
        case this.translateService.instant('TABLAS.wsdef'): { 
          if(this.permissionsType[i].permissionableId === this.wsdefs.id){
            this.permissionsTypeTrue.push(this.permissionsType[i]);
          }
          break; 
        } 
        case this.translateService.instant('TABLAS.typefinder'): { 
          if(this.permissionsType[i].permissionableId === this.typefinders.id){
            this.permissionsTypeTrue.push(this.permissionsType[i]);
          }
          break; 
        } 
        case this.translateService.instant('TABLAS.xmlfield'): { 
          if(this.permissionsType[i].permissionableId === this.xmlfields.id){
            this.permissionsTypeTrue.push(this.permissionsType[i]);
          }
          break; 
        } 
      } 
    }

    let permisoTipo = this.permissionsType[0].operationId.type;

    for(let i = 0; i < this.operations.length; i++){
      if(this.operations[i].type === permisoTipo){
        this.tipoRol.push(this.operations[i].code);
        this.tipoId.push(this.operations[i].id);
      }
    }

    for(let i = 0; i < this.rols.length; i++){
      for(let j = 0; j < this.permissionsTypeTrue.length; j++){
        if(this.rols[i].id === this.permissionsTypeTrue[j].rolId.id && this.permissionsTypeTrue[j].operationId.code === this.tipoRol[0]){
          this.rols[i].operacion1 = true;
        }

        if(this.rols[i].id === this.permissionsTypeTrue[j].rolId.id && this.permissionsTypeTrue[j].operationId.code === this.tipoRol[1]){
          this.rols[i].operacion2 = true;
        }

        if(this.clase === this.translateService.instant('TABLAS.xmlfield')){
          if(this.rols[i].id === this.permissionsTypeTrue[j].rolId.id &&  this.permissionsTypeTrue[j].visibility === 1){
            this.rols[i].operacion3 = true;
          }
        }
      }
    }

    this.rols.sort();
    this.originalRols =  _.cloneDeep(this.rols);
    this.originalRolsFiltro =  _.cloneDeep(this.rols);
  }

  build() {}
}
